<script lang="ts" setup>
import helpers from '~/helpers'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()
</script>

<template>
  <Notification v-if="cartStore.isShippingCostKnown" is-small status="info">
    <template v-if="cartStore.isFreeShippingEnabledBySubtotal">
      Доставка по&nbsp;акции будет бесплатной после выбора ПВЗ.
    </template>
    <template v-else-if="cartStore.isFreeShippingEnabledByPromoCode">
      Доставка по&nbsp;промокоду будет бесплатной после выбора ПВЗ.
    </template>
    <template v-else-if="cartStore.fixedShippingCostInKopecks !== null">
      <template v-if="cartStore.fixedShippingCostInKopecks === 0">
        Доставка будет бесплатной после выбора ПВЗ.
      </template>
      <template v-else>
        Доставка будет стоить {{ helpers.formatPrice(cartStore.fixedShippingCostInKopecks, true) }}&nbsp;₽ после выбора ПВЗ.
      </template>
    </template>
  </Notification>
</template>
